import { PagePathService } from '@/src/services/PagePathService'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useLoginUser } from '../../states/LoginUser'
import { Props } from './Layout'
import { useFirebaseUser } from '../../states/FirebaseUser'
import { AuthService } from '@/src/services/AuthService'

export const useProps = (): Props => {
  const { firebaseUser, isLoading: isFirebaseLoading } = useFirebaseUser()
  const { isLoading: isLoginUserLoading, reload, loginUser } = useLoginUser()
  const router = useRouter()

  useEffect(() => {
    reload()
  }, [reload])

  return {
    type:
      loginUser && firebaseUser && AuthService.isLoggedIn()
        ? 'LoggedIn'
        : isLoginUserLoading || isFirebaseLoading
        ? 'Loading'
        : 'NO_Login',
    onClickLogin: () => router.push(PagePathService.login()),
  }
}
